import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import saveAs from "file-saver";
import * as microsoftTeams from '@microsoft/teams-js';


export const DownloadFile = async (url: string, token: string): Promise<Blob> => {
    const params: AxiosRequestConfig = {
        timeout: 20000, // 20 seconds
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        responseType: 'blob',
    };

    const instance: AxiosInstance = axios.create(params);
    return instance
        .get(url)
        .then((res: AxiosResponse) => {
            return res.data as Blob;
        });
};

export const DownloadFileAndSave = async (url: string, token: string) => {
    const params: AxiosRequestConfig = {
        timeout: 20000, // 20 seconds
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        responseType: 'blob',
    };

    const instance: AxiosInstance = axios.create(params);
    instance
        .get(url)
        .then((res: AxiosResponse) => {
            let filename = "Neomytic";
            const disposition = res.headers['content-disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            saveAs(res.data as Blob, filename);
        });
};

export const NavToLink = async (url: string) => {
    if (microsoftTeams.app.isInitialized()) {
        microsoftTeams.app.openLink(url)
            .then(() => { console.log("Nav to " + url); })
            .catch((reason) => {
                console.log(reason);
            });
    }
    else {
        window.open(url, '_blank');
    }
};

export const DownloadSPOLinkAndNav = async (url: string, token: string) => {
    const params2: AxiosRequestConfig = {
        timeout: 20000, // 20 seconds
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    };

    const instance2: AxiosInstance = axios.create(params2);
    instance2
        .get(url)
        .then((res: AxiosResponse) => {
            NavToLink(res.data.linkingUri ? res.data.linkingUri : res.data.absoluteUrl);
        });
};
